import { Provider } from 'react-redux';

// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider } from 'src/components/settings';
import ProgressBar from 'src/components/progress-bar';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import MainDrawer from 'src/components/main-drawer';
import GamePlayModal from 'src/components/game-item/game-play';

import { store } from './store';
import { ApiProvider } from './contexts/ApiContext';

// ----------------------------------------------------------------------

export default function App() {
  const charAt = `

  ░░                    ░░                 ░░                          
  ▓▓                    ▓▓                 ▓▓                          
  ▓▓                  ▓▓▓▓▓▓▓              ▓▓   █▓▓                    
  ▓▓█▓▓      ███████    ▓▓       ███████   ▓▓ █▒▓     ▓▓▓▓██    ███████
  ▓▓  █▒▓   ▒▒          ▓▓             ▒▓  ▓▓▓▓      ▓▓    ▒▓  ▒▒      
  ▓▓    ▓▓  ▓▓█████     ▓▓        █████▓▓  ▓▓ ▒▓     ▓▓████▓   ▓▓█████ 
  ▓▓  █▒▓         ▓▓    ▓▓       ▒█    ▒▓  ▓▓  ▒▓    ▓▓              ▓▓
  ▓▓█▓▓     ██████▓▓    ▓▓███▒▓  ▒█████▓▓  ▓▓   ▒▓█   ▓██████  ██████▓▓
  
  `;

  console.info(`%c${charAt}`, 'color: #ed1a24');

  useScrollToTop();

  return (
    <Provider store={store}>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'light', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'blue', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
        }}
      >
        <ThemeProvider>
          <MotionLazy>
            <SnackbarProvider>
              <MainDrawer />
              <ProgressBar />
              <ApiProvider>
                <Router />
              </ApiProvider>
              <GamePlayModal />
            </SnackbarProvider>
          </MotionLazy>
        </ThemeProvider>
      </SettingsProvider>
    </Provider>
  );
}
